/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCommunityMemberMinimal {
    'profile_id': string | null;
    'handle': string | null;
    'normalised_handle': string | null;
    'primary_wallet': string | null;
    'display': string | null;
    'tdh': number;
    'level': number;
    'cic_rating': number;
    'wallet': string;
    'pfp': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "profile_id",
            "baseName": "profile_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "handle",
            "baseName": "handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "normalised_handle",
            "baseName": "normalised_handle",
            "type": "string",
            "format": ""
        },
        {
            "name": "primary_wallet",
            "baseName": "primary_wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "display",
            "baseName": "display",
            "type": "string",
            "format": ""
        },
        {
            "name": "tdh",
            "baseName": "tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "level",
            "baseName": "level",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cic_rating",
            "baseName": "cic_rating",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "wallet",
            "baseName": "wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "pfp",
            "baseName": "pfp",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCommunityMemberMinimal.attributeTypeMap;
    }

    public constructor() {
    }
}
